(function ($, angular, window) {
    'use strict';

    window.THF.Angular.JoinForm.directive('thfFieldTextPrivate', ['thfFieldHelper', '$sce', function (thfFieldHelper, $sce) {
        var link = function (scope, el) {
            scope.isValid = thfFieldHelper.isValid;
            scope.labelIdentifier = thfFieldHelper.formLabelIdentifier();
            scope.fieldType = 'password';
            scope.toggleType = function(event) {
                event.preventDefault();
                event.stopPropagation();
                
                scope.fieldType = scope.fieldType == 'password' ? 'text' : 'password';
            }
            
            scope.tooltip = $sce.trustAsHtml(scope.field.tooltip);

            scope.lastKeyPressed = 0;
            scope.preventLengthyPaste =  function(event) {
                if(typeof scope.field.maxLength === 'undefined') {
                    return true;
                }

                scope.lastKeyPressed = event.keyCode;

                var value = event.target.value;
                if(scope.lastKeyPressed != 8 && scope.lastKeyPressed != 46) {
                    scope.model[scope.field.name] = value.substring(0, scope.field.maxLength);
                }
            }

            scope.$watch('model.'+scope.field.name, function(newValue, oldValue) {
                if(oldValue !== newValue) {
                    scope.model[scope.field.name] = thfFieldHelper.escapeValue(scope.model[scope.field.name]);
                }
            }, true);
        };
        return {
            'restrict': 'E',
            'replace': true,
            'scope': {
                'formState': '=',
                'formField': '=',
                'formModel': '=',
                'field': '=',
                'validation': '=',
                'model': '=',
                'fieldActions': '=',
                'validationRules': '='
            },
            'link': link,
            'templateUrl': function () {
                return THF.Utility.Location.cacheBustUrl('/static/views/join-form/fields/text-private.html');
            }
        };
    }]);
})(jQuery, angular, window);
